import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import { Text } from "react-native";
import { useAssessmentEdit } from "../context/AssessmentEditContext";
import { useAssessmentEditPage } from "../context/AssessmentEditPageContext";

interface Props {
  sectionIndex: number;
}
export function SectionPageOrderAtom({ sectionIndex }: Props) {
  const { control, hasPages } = useAssessmentEdit();
  const { lastPage, pageIndex, moveSectionToPage } = useAssessmentEditPage();

  if (!hasPages) return null;

  return (
    <View className="bg-gray-100 rounded p-1">
      <ButtonTextLabel>Page</ButtonTextLabel>
      <View className="flex flex-row gap-2">
        <Button
          size="xs"
          variant="link"
          onPress={() => {
            moveSectionToPage({
              toPageIndex: pageIndex - 1,
              sectionIndex,
            });
          }}
          isDisabled={pageIndex <= 0}
        >
          <ButtonIcon as={ChevronUpIcon} className="min-w-6" />
        </Button>
        <Button
          size="xs"
          variant="link"
          onPress={() => {
            moveSectionToPage({
              toPageIndex: pageIndex + 1,
              sectionIndex,
            });
          }}
          isDisabled={lastPage}
        >
          <ButtonIcon as={ChevronDownIcon} className="min-w-6" />
        </Button>
      </View>
    </View>
  );
}

function ButtonTextLabel({ children }: { children: string }) {
  return (
    <View>
      <Text className="text-[0.5rem] uppercase text-center text-black text-semibold">
        {children}
      </Text>
    </View>
  );
}
